import React from "react";
import { useLocation, Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  StyledHeading,
  StyledCardMedia,
  StyledCardContent,
  RightRailVideoAnchor,
} from "./_.styled";
import {
  Anchor,
  Flex,
  Card,
  VideoPlayerPoster,
} from "discover.medical.react-component-library";
import { getVideoUrl, transformations } from "../../util/get-url-utils";
import useVideo from "../../hooks/useVideo";
import ViewInContextMenu from "../ViewInContextMenu";

const ContentRightRailVideo = ({
  label,
  videos = [],
  handleOpenLightBoxVideo,
  testId,
  slugTitle,
  slugPubType,
  isMobileDevice,
  isTabletDevice,
}) => {
  const { pathname: curSlugUrl } = useLocation();
  const { cloudinaryUrl } = useVideo();
  const video = videos[0];

  return (
    <div data-testid={testId}>
      {videos.length && (
        <>
          <Flex container justify={{ content: "space-between" }}>
            <StyledHeading element="h5" fontFamily="primary">
              {label}
            </StyledHeading>
            <Anchor linkComponent={Link} href={`${curSlugUrl}/videos`}>
              All ({videos.length})
            </Anchor>
          </Flex>

          <Card borderColor="gray400" borderStyle="solid" borderWidth="1px">
            <RightRailVideoAnchor
              data-auto="rightrail-video-anchor"
              data-testid="right-rail-video-anchor"
              onClick={(e) => {
                e.preventDefault();
                handleOpenLightBoxVideo();
              }}
            >
              <StyledCardMedia
                borderBottomColor="gray400"
                borderBottomStyle="solid"
                borderBottomWidth="1px"
              >
                <VideoPlayerPoster
                  lazyLoad={false}
                  url={`${getVideoUrl(
                    video.publicId,
                    cloudinaryUrl,
                    transformations.small
                  )}.jpg`}
                  alt={video.title}
                  style={{ maxWidth: "inherit", maxHeight: "inherit" }}
                />
              </StyledCardMedia>
            </RightRailVideoAnchor>

            <StyledCardContent>
              <Anchor
                data-testid="right-rail-video-title"
                data-auto="rightrail-video-title"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenLightBoxVideo();
                }}
              >
                {video.title}
              </Anchor>
              {video?.associatedTopics &&
                ViewInContextMenu({
                  associatedTopics: video.associatedTopics,
                  slugTitle,
                  slugPubType,
                  isRightRail: true,
                  isMobileDevice,
                  isTabletDevice,
                })}
            </StyledCardContent>
          </Card>
        </>
      )}
    </div>
  );
};

ContentRightRailVideo.propTypes = {
  label: PropTypes.string,
  testId: PropTypes.string.isRequired,
  videos: PropTypes.arrayOf(
    PropTypes.shape({
      copyright: PropTypes.string,
      publicId: PropTypes.string,
      description: PropTypes.string,
      title: PropTypes.string.isRequired,
    }).isRequired
  ),
};

ContentRightRailVideo.displayName = "ContentRightRailVideo";

export default ContentRightRailVideo;
